import '../media/css/Auth.css';
import React from 'react';
import {Container, Row, Col, Form, Button, Input, Label} from 'reactstrap';
import AddToHomeScreen from "./AddToHomeScreen.mjs";
import AppModeSwitcher from "./AppModeSwitcher.mjs";

const glob = window.glob;
const prop = {
	emailField_id: 'prenotazioni_auth_email_field',
	sendOtpButton_id: glob.generateUid(),
	otpField_id: glob.generateUid(),
	alertArea_id: glob.generateUid()
};

const isValidEmail = (str) => {
	return String(str).match(/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i);
}

function onEmailChange() {
	const emailField = document.getElementById(prop.emailField_id);
	let ne = String(emailField.value);
	const vld = isValidEmail(ne);
	enableOtpButton(vld);
	emailField.classList.remove("is-valid", "is-invalid");
	emailField.classList.add(vld ? 'is-valid' : 'is-invalid');
	prop.email = ne;
}

function onVerifyChange() {
	const otpField = document.getElementById(prop.otpField_id);
	let otp = String(otpField.value).replace(/[^0-9]/g, '');
	if (otp.match(/^[0-9]{6}$/)) {
		otp = otp.replace(/^([0-9]{3})([0-9]{3})$/, "$1-$2");
		otpField.value = otp;
	}
	const vld = !!otp.match(/^[0-9]{3}-[0-9]{3}$/);
	enableOtpButton(vld);
	otpField.classList.remove("is-valid", "is-invalid");
	otpField.classList.add(vld ? 'is-valid' : 'is-invalid');
	prop.otp = otp;
}

function enableOtpButton(mode) {
	const sendOtpButton = document.getElementById(prop.sendOtpButton_id);
	sendOtpButton.disabled = !mode;
	sendOtpButton.classList[mode ? 'remove' : 'add']('disabled');
}

class OtpButton extends React.Component {
	render() {
		return (
			<Button type="submit" id={prop.sendOtpButton_id} color="success" className={this.props.className}>
				{this.props.text}
			</Button>
		);
	}
}

class AuthAlert extends React.Component {
	constructor(props) {
		super(props);
		this.state = {};
	}

	manage() {
		let txt = this.props.text();
		if ((this.props.crea !== this.state.crea) || (txt !== this.state.prevmsg)) {
			if (this.timerId) clearTimeout(this.timerId);
			this.timerId = setTimeout(() => {
					this.setState({msg: false});
				}, 4000
			);
			this.setState({msg: txt, prevmsg: txt, crea: this.props.crea});
		}
	}

	componentDidMount() {
		this.manage();
	}

	componentDidUpdate() {
		this.manage();
	}

	render() {
		return (
			<div className={this.state.msg ? "alert alert-warning mt-2" : "d-none"} role="alert">
				{this.state.msg || ''}
			</div>
		);
	}
}

class Auth extends React.Component {
	constructor(opts) {
		super(opts);
		this.state = {phase: 1};
		this.sendAuthOtp = this.sendAuthOtp.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
		this.verifyAuthOtp = this.verifyAuthOtp.bind(this);
		this.getError = this.getError.bind(this);
		prop.main = this;
		prop.otp = "";
	};

	getError() {
		return this.state.error;
	}

	handleSubmit(e) {
		e.preventDefault();
		switch (this.state.phase) {
			case 1:
				this.sendAuthOtp.call(this);
				break;
			case 2:
				this.verifyAuthOtp.call(this);
				break;
		}
	};

	sendAuthOtp() {
		if (!(prop.email && isValidEmail(prop.email))) return void (0);
		enableOtpButton(false);
		const emailField = document.getElementById(prop.emailField_id);
		emailField.disabled = true;
		const uri = glob.getUri('auth');
		delete prop.error;
		prop.otp = "";
		glob.prop.traffic.calls++;
		glob.prop.traffic.pending++
		glob.appStatus();
		window.fetch(
			uri,
			{
				method: 'POST',
				cache: 'no-cache',
				headers: {
					"X-not-yet-auth": "true",
					"X-auth-action": "sendOtp",
					'Accept': 'application/json',
					'Content-Type': 'application/json'
				},
				body: JSON.stringify({email: prop.email})
			}
		).then(response => {
			if (!response.ok) throw response;
			return response.json();
		}).then(jdata => {
			if (!jdata.success) throw jdata;
			prop.email = jdata.message;
			glob.appStatus();
			this.setState({phase: 2, refresh: new Date(), error: false});
		}).catch((e) => {
			emailField.disabled = false;
			glob.prop.traffic.errors++;
			glob.prop.traffic.inerror++;
			glob.appStatus();
			if (e && e.error === 404) {
				this.setState({phase: 1, error: "Verificare l’indirizzo di email “" + prop.email + "”."});
			} else {
				this.setState({
					phase: 1,
					error: "Si è verificato un errore accedendo al server. Riprova.",
					refresh: new Date()
				});
			}
		}).finally(() => {
			glob.prop.traffic.pending--;
		});
	};

	verifyAuthOtp() {
		if (!(prop.email && isValidEmail(prop.email))) return void (0);
		if (!prop.otp.match(/^[0-9]{3}-[0-9]{3}$/)) return void (0);
		const otpField = document.getElementById(prop.otpField_id);
		enableOtpButton(false);
		otpField.disabeld = true;
		const uri = glob.getUri('auth');
		delete prop.error;
		glob.prop.traffic.calls++;
		glob.prop.traffic.pending++
		glob.appStatus();
		window.fetch(
			uri,
			{
				method: 'POST',
				cache: 'no-cache',
				headers: {
					"X-not-yet-auth": "true",
					"X-auth-action": "verifyOtp",
					'Accept': 'application/json',
					'Content-Type': 'application/json'
				},
				body: JSON.stringify({email: prop.email, otp: prop.otp})
			}
		).then(response => {
			if (!response.ok) throw response;
			return response.json();
		}).then(jdata => {
			if (!jdata.success) throw jdata;
			glob.appStatus();
			this.setState({phase: 3, error: false, ldata: jdata});
		}).catch((e) => {
			glob.prop.traffic.errors++;
			glob.prop.traffic.inerror++;
			glob.appStatus();
			otpField.disabled = false;
			this.setState({phase: 2, error: "OTP non valida.", refresh: new Date()});
		}).finally(() => {
			glob.prop.traffic.pending--;
		});
	};

	postreview() {
		switch (this.state.phase) {
			case 1:
				const emailField = document.getElementById(prop.emailField_id);
				emailField.value = prop.email || glob.getStatus("lastUsedEmail") || "";
				onEmailChange();
				emailField.focus();
				break;
			case 2:
				const otpField = document.getElementById(prop.otpField_id);
				otpField.value = prop.otp;
				onVerifyChange();
				otpField.focus();
				break;
			case 3:
				glob.loginSucceded(this.state.ldata.email, this.state.ldata.sessionId);
				break;
		}
	}

	componentDidMount() {
		this.postreview();
	}

	componentDidUpdate() {
		this.postreview();
	}

	buildEmailForm() {
		return (
			<>
				<Row>
					<Col md={12} className="text-center">
						<h3>Autenticazione</h3>
					</Col>
				</Row>
				<Row>
					<Label>
						Una password usa e getta <em>(One Time Password)</em> verrà inviata all’indirizzo di email,
						se tale indirizzo email è autorizzato all’accesso.
					</Label>
				</Row>
				<Row>
					<Col md={8}>
						<Input
							id={prop.emailField_id}
							onKeyUp={onEmailChange}
							onChange={onEmailChange}
							type={"email"}
							placeholder={"Indirizzo email ufficiale autorizzato"}
						/>
					</Col>
					<Col md={4} className="text-center">
						<OtpButton text={"Invia OTP →"} disabled={true} className={"w-100"}/>
					</Col>
				</Row>
			</>
		);
	};

	buildOtpForm() {
		return (
			<>
				<Row>
					<Col md={12} className="text-center">
						<h3>Verifica</h3>
					</Col>
				</Row>
				<Row>
					<Label className="text-center mb-lg-3">
						Inserisci la password usa e getta (OTP) che è stata inviata a<br/>
						<b><em>{prop.email}</em></b>
					</Label>
				</Row>
				<Row>
					<Col md={4}>
						<Button onClick={() => {
							this.setState({phase: 1})
						}} color="warning" className={"w-100"}>← Annulla</Button>
					</Col>
					<Col md={4} className="text-center">
						<Input
							id={prop.otpField_id}
							onKeyUp={onVerifyChange}
							onChange={onVerifyChange}
							disabled={false}
							type={"text"}
							placeholder={"XXX-XXX"}
							inputMode={"numeric"}
							pattern="\d{3}-\d{3}"
							required
						/>
					</Col>
					<Col md={4} className="text-center">
						<OtpButton text={"Verifica OTP →"} disabled={true} className={"w-100"}/>
					</Col>
				</Row>
				<Row>
					<Label className="mt-lg-3">
						Se non ricevi la mail verifica di aver scritto correttamente l’indirizzo di email.<br/>
						Se l’indirizzo è corretto controlla anche che la mail di verifica non sia stata erroneamente
						catalogata come Spam (posta indesiderata).<br/>
						<strong>N.B.: <em>La mail viene inviata solo agli indirizzi email autorizzati per le
							Prenotazioni.</em></strong>
					</Label>
				</Row>
			</>
		);
	}

	verificationOkForm() {
		return (
			<>
				<Row>
					<Col md={12} className="text-center">
						<h3>OTP verificata</h3>
					</Col>
				</Row>
				<Row>
					<Col md={12} className="text-center">
						Avvio sessione in corso…
					</Col>
				</Row>
			</>
		);
	}

	getError() {
		return this.state.error;
	}

	render() {
		let f;
		switch (this.state.phase) {
			case 1:
				f = this.buildEmailForm();
				break;
			case 2:
				f = this.buildOtpForm();
				break;
			case 3:
				f = this.verificationOkForm();
				break;
		}
		return (
			<>
				<Container className="AppAuthArea">
					<Form onSubmit={this.handleSubmit}>
						{f}
						<Row>
							<Col md={12}>
								<AuthAlert text={this.getError} crea={new Date()}/>
							</Col>
						</Row>
					</Form>
				</Container>
				<AddToHomeScreen/>
				<AppModeSwitcher/>
			</>
		);
	};
}

export default Auth;